/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMyReservationInvoicesPathParameters } from 'api/actions/get-my-reservation-invoices/get-my-reservation-invoices-path-parameters';
import { GetMyReservationInvoicesResponse } from 'api/actions/get-my-reservation-invoices/get-my-reservation-invoices-response';

type GetMyReservationInvoicesQueryParameters = Record<string, any>;

/**
 * The path of the GetMyReservationInvoices action.
 */
export const getMyReservationInvoicesActionPath = new SweetPath<keyof GetMyReservationInvoicesPathParameters>(
  '/reservations/invoices',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetMyReservationInvoices actions.
 */
export default function createGetMyReservationInvoicesAction(axios: AxiosInstance) {
  return function getMyReservationInvoicesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetMyReservationInvoicesQueryParameters } = {}) {
    const path = getMyReservationInvoicesActionPath.original;

    return axios.get<GetMyReservationInvoicesResponse, GetMyReservationInvoicesResponse>(path, {
      params: query,
      headers,
    });
  };
}
